import { render, staticRenderFns } from "./DataSelect.vue?vue&type=template&id=3caa05fe&"
import script from "./DataSelect.vue?vue&type=script&lang=js&"
export * from "./DataSelect.vue?vue&type=script&lang=js&"
import style0 from "./DataSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
